<template>
    <b-container fluid class="mt--7">
        <view-item
            v-if="!!item"
            :item="item"
            @success="alertSuccess"
            @delete-item="deleteType"
            @cancel="item = null"
            @error="showError"
        ></view-item>

        <list-items
            v-if="!item"
            title="ItemTypes"
            :items="assetTypes"
            @show-item="showItem"
            ref="table"
        >
            <b-row>
                <b-col offset="8" class="text-right">
                    <b-button variant="primary" v-show="hasPermissionCreate" @click="item = {}"
                        >Add Type</b-button
                    >
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

export default {
    name: 'AssetTypes',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins, errorHandlingMixins],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        assetTypes() {
            const types = this.$store.state.assets.types
            console.log('types', types)
            return types
        },
    },

    methods: {
        doSearch() {
            this.$store.dispatch('assets/listTypes')
        },

        showItem(id) {
            const item = this.assetTypes.find(x => x.id === id)
            this.item = {...item}
        },

        alertSuccess(message) {
            this.doToast('Success', `Asset Type ${message}!`, 'success')
            this.item = null
            this.doSearch()
        },
    },
}
</script>
<style></style>
